import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { deserializeFicheDePreps } from '@teetsh/app/src/queries/sequences/serializer';

export function getFicheDePrep(sequenceId?: string, ficheDePrepId?: string) {
  return request(`/sequences/${sequenceId}/fiches-de-prep/${ficheDePrepId}`, {
    method: 'GET',
  }).then(res => deserializeFicheDePreps(res));
}

export const fdpQueryKeys = {
  detail: (sequenceId?: string, ficheDePrepId?: string) => [
    'fdp',
    sequenceId,
    ficheDePrepId,
  ],
};

export default function useFicheDePrep(
  sequenceId?: string,
  ficheDePrepId?: string,
) {
  return useQuery({
    queryKey: fdpQueryKeys.detail(sequenceId, ficheDePrepId),
    queryFn: () => getFicheDePrep(sequenceId, ficheDePrepId),
    refetchOnWindowFocus: true,
    enabled: !!sequenceId && !!ficheDePrepId,
  });
}
